import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

//Guards
import { AuthGuard } from "./services/guards/auth.guard";

//Components
import { PagesComponent } from "./pages/pages.component";

const appRoutes: Routes = [
  {
    path: "pages",
    component: PagesComponent,
    canActivate: [AuthGuard],
    loadChildren: "./pages/pages.module#PagesModule",
  },
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "**", redirectTo: "/login", pathMatch: "full" },
];

export const appRoutingProviders: any[] = [];
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);
